module.exports = __webpack_public_path__ + "static/media/icon-messages.c356912a.svg";